const MIN_AMOUNT_IN_CENTS = 50;

export default (amount) => (!!amount && amount < MIN_AMOUNT_IN_CENTS) || amount === 0;
